import {where} from "firebase/firestore";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerTotalRendimientos = async (idUsuario) => {


    let wRendimientos = [where('idUsuario', '==', idUsuario), where('tipo', '==', 'Rendimientos'), where('estado', 'in', ['Aceptado', 'Validando'])]
    let rendimientos = await contarSumaWhere({coleccion: 'movimientos', wheres: wRendimientos, propiedad: 'valor'})


    return rendimientos.data
}